import { jsx as _jsx } from "react/jsx-runtime";
import { Column, Columns } from '@dixa/lib-shared-habla';
import styles from './contactDetails.module.scss';
export function ContactsDetails({ children }) {
    return (_jsx(Columns, { children: _jsx(Column.Row, Object.assign({ scrollable: true, size: 1, className: styles.row }, { children: children })) }));
}
